import mixins from '@synergycms_core/less/mixins.js';

export default {
    portalDesign:{},
    searchButton:{},
    buttonContainer:{},
    searchIcon:{},
    dispoModal:{},
    DESK :{},
    MOBIL:{},
    TABLET:{},
    roundedTheme:{},
    engineMerged:{},
    defaultStyle: data => ({
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        marginBottom: 0,
        zIndex: 1,
        backgroundColor: '#fff',
        display: 'table-cell',
        verticalAlign:"middle",
        [`@media (min-width: ${data.modalBreak}px)`]: {
            borderRight: 'none',
            minWidth: '150px',
            position: 'relative',
            background:'none',
            width:'22%',
            '&$roundedTheme':{
                '& $buttonContainer':{
                    backgroundColor: 'unset',
                }
            }
        },
        '&:lang(ar)': {
            [`@media (min-width: ${data.modalBreak}px)`]: {
                borderLeft: 'none'
            }
        },
        '& $buttonContainer':{
            backgroundColor: data.backgroundColor,
            '& $searchButton': {
                height: '49px',
                font: 'italic 16px ' + data.fontFamily2,
                '&:hover': {
                    backgroundColor: data.mainColor + ' !important',
                    color: '#fff!important',
                    opacity: '.75',
                    ...mixins.transitionAll()
                },
                '& > span': {
                    '&:lang(ar)': {
                        display: 'inline-block'
                    }
                },
                '&:lang(ar)': {
                    display: 'flex',
                    justifyContent: 'center',
                    direction: 'rtl',
                    [`@media (min-width: ${data.modalBreak}px)`]: {
                    flexDirection: 'unset',
                    }
                },
                '& $searchIcon': {
                    fontSize: '19px',
                    lineHeight: '15px',
                    marginRight: '15px',
                    verticalAlign: 'middle',
                    '&:lang(ar)': {
                        marginRight: '0',
                        marginLeft: '15px'
                    }
                },
            },
        },
        '&$portalDesign':{
            '&:not($dispoModal)':{
                position:'static',
                width:'auto',
                '& $buttonContainer':{
                    '& $searchButton':{
                        height:'55px',
                        backgroundColor:  data.mainColor + '!important',
                        borderColor: data.mainColor,
                        minWidth:'50px',
                        cursor:'pointer',
                        '& $searchIcon':{
                            margin:0,
                            [`@media (min-width: ${data.modalBreak}px)`]: {
                                display: 'none'
                            },
                        },
                        [`@media (min-width: ${data.modalBreak}px)`]:{
                            height:'80px',
                            textTransform:'uppercase',
                            letterSpacing:'0.5px',
                            font: 'bold 18px ' + data.fontFamily1,
                            '&:hover':{
                            borderColor: data.mainColor + '!important',
                            },
                            '&:lang(ar)':{
                            display: 'block',
                            }
                        },
                        '&:lang(ar)': {
                            alignItems: 'center',
                        }
                    },
                },
                '@media (max-width: 1023px)': {
                    width: '90px',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    position: 'relative'
                }
            },
            '&$engineMerged':{
                '@media (min-width: 1024px) and (max-width:1200px)':{
                    minWidth: '100px',
                    width: '20%',
                },
                '& $searchText':{
                    display: 'inline-block',
                    maxWidth: '100px',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    margin: '0 5px',
                    textWrap: 'nowrap'
                }
            }
        },
        '&$roundedTheme':{
            '& $buttonContainer':{
                '& $searchButton':{
                    borderRadius: '25px'
                }
            }
        }
    }),
    searchText:{}
};